export default "__VITE_ASSET__uqchERek__"